// import Vue from "vue/types/index";
import axios from 'axios';
// 导入NProgress, 包对应的JS和CSS

//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
//axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
//获取左侧菜单列表时公用请求头
//axios.defaults.headers.common['Authentication-Token'] = localStorage.getItem('token5');
//axios.defaults.timeout = 30 * 1000; // 30s
axios.interceptors.request.use((config) => {
    // // 需要在请求发出前做的全局处理逻辑可以添加在这里
    // config.url = config.url;
    // config.headers['Authentication-Token'] = localStorage.getItem('token')
    return config;
}, (error) => {
    // 可以在这里统一处理请求错误
    Promise.reject(error);
});
axios.interceptors.response.use(config => {
    return config
  })
export default axios
